"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _config = require("./config");
var _common = require("../../../common");
var salesPromotionApi = _interopRequireWildcard(require("../../../api"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import paginationEffect from '@/utils/paginationEffect';
var _default = exports.default = {
  name: 'EffectAnalysis',
  data: function data() {
    return {
      cards: _config.cards,
      commonData: _common.commonData,
      timeFormat: _common.timeFormat,
      // ...paginationEffect(this.handlerGetListData),
      tableData: {
        list: [],
        total: 0
      },
      loading: false,
      tableLoading: false,
      searchForm: {},
      info: {
        coupon: {}
      }
    };
  },
  created: function created() {
    var promoId = this.$route.path.split('/').pop();
    this.$set(this.searchForm, 'promoId', promoId);
    this.init();
    this.getDetail();
  },
  methods: {
    init: _common.init,
    getDetail: function getDetail() {
      var _this = this;
      this.loading = true;
      salesPromotionApi.statisticsApi(this.handleParams()).then(function (res) {
        _this.handleInfo(res);
        _this.loading = false;
      }).catch(function (err) {
        _this.loading = false;
      });
    },
    handleInfo: function handleInfo(res) {
      this.info = res;
      this.tableData.list = res.couponStatisticsDetailVoList;
    },
    handleParams: function handleParams() {
      var params = _objectSpread({}, this.searchForm);
      if (params.time) {
        params.start = params.time[0];
        params.endT = params.time[1];
        delete params.time;
      }
      if (params.customerIds) {
        params.customerIds = params.customerIds.join(',');
      }
      return params;
    },
    // async search() {
    //   this.tableLoading = true;
    //   try {
    //     const res = await statisticsApi(this.searchForm);
    //     this.tableData = res
    //     this.tableLoading = false;
    //   } catch (error) {
    //     this.tableLoading = false;
    //   }
    // },
    customerFormatter: function customerFormatter(row) {
      var _row$customerResponse;
      return (_row$customerResponse = row.customerResponse) === null || _row$customerResponse === void 0 ? void 0 : _row$customerResponse.name;
    }
  }
};